import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { CustomerOverViewService } from '~features/customer-overview/customer-overview.service';
import { NotificationType } from '~core/enum';
import { Customer, TixxConnection, TixxConnectionProvider } from '~core/models';
import { DefaultNotificationService, TixxConnectionService } from '~core/services';


/**
 * Displays the Tixx iframe in our application.
 */
@UntilDestroy()
@Component({
  selector: 'app-tixx-connection',
  template: '',
  styles: ['']
})
export class TixxConnectionComponent implements OnInit, OnDestroy {
  public loading: boolean = true;
  public modalOpened: boolean = false;
  public tixxConnectionData: TixxConnection;
  @Input()
  public customer: Customer;
  private miliSecondsUntilShown: number = 400;

  constructor(
    public customerService: CustomerOverViewService,
    private notificationService: DefaultNotificationService,
    private tixxConnectionService: TixxConnectionService
  ) { }

  /**
   * Call getTixxConnectionData on init.
   */
  public ngOnInit(): void {
    this.tixxConnectionService.getTixxConnection().pipe(untilDestroyed(this))
      .subscribe((data: TixxConnectionProvider) => {
        if (data !== null && data.open) {
          this.getTixxConnectionData(data.bankAccountId, data.reservationId);
        }
      });
  }

  /**
   * Fetch tixx connection data.
   */
  private getTixxConnectionData(bankAccountId?: number, reservationId: string = null): void {
    this.tixxConnectionService.getData(this.customer, bankAccountId, reservationId).pipe(untilDestroyed(this))
      .subscribe({
        next: (data: TixxConnection) => {
          if (this.isTixxDataComplete(data)) {
            this.tixxConnectionService.announceTixxConnectionEstablished();
            this.tixxConnectionData = new TixxConnection(data);

            setTimeout(() => {
              this.tixxConnectionService.openTixxIframe(this.tixxConnectionData);
            }, this.miliSecondsUntilShown);
          } else {
            this.notificationService.showNotification({
              type: NotificationType.WARNING,
              message: this.tixxConnectionService.i18nErrorCouldNotEstablishTixx
            });
          }
        },
        error: (error: Error) => {
          this.notificationService.showNotification({
            type: NotificationType.ALERT,
            message: this.tixxConnectionService.i18nErrorVerifyConnectionTixx
          });
        }
      });
  }

  /**
   * Checks if data is not empty.
   */
  private isTixxDataComplete(tixxData: TixxConnection): boolean {
    for (const value in tixxData) {
      if (tixxData[value] === '' || tixxData[value] === null) {
        return false;
      }
    }

    return true;
  }

  /**
   * Unsubscribe from subscription to avoid memory leaks.
   */
  public ngOnDestroy(): void {
    this.tixxConnectionService.clearTixxConnection();
    this.tixxConnectionService.clearTixxEstablishedConnection();
  }
}
